import { Directive, Input, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[miqIndent]',
  standalone: false,
})
export class IndentDirective implements OnInit {
  constructor(private el: ElementRef) {}

  @Input() miqIndent: number;

  ngOnInit() {
    if (this.miqIndent && this.el) {
      this.el.nativeElement.style.marginLeft = `${this.miqIndent * 38}px`;
    }
  }
}
